<template>
  <div v-if="(department && department.uuid) || withAllCategories || propItems" :key="'category-input-widget-field'">
    <input-widget :model="model"
                  :attribute="attribute"
                  type="treepicker"
                  :disabled="disabled"
                  display-field="${item.name}"
                  @onTreepickerSelect="onSelect"
                  :hint="hint"
                  :label="label"
                  :placeholder="computedPlaceholder"
                  :tree-picker-options="treePickerOptions"
                  :items="items"/>
  </div>
  <div v-else :key="'category-disabled-input-widget-field'">
    <input-widget :model="model" :attribute="attribute" disabled :label="label"/>
  </div>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import {Formatter} from "@/core/services/formatter.service";
  import CategoryService from "@/modules/setup/category/CategoryService";

  const {mapState: mapStateDepartment} = createNamespacedHelpers('setup/department');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CategorySelectInputWidget",
    components: {InputWidget},
    data() {
      return {
        items: []
      }
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      department: {
        type: [Object],
        required: false,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      withAllCategories: {
        type: Boolean,
        default: false
      },
      showDepartmentInName: {
        type: Boolean,
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return {}
        }
      },
      propItems: {
        type: Array,
        default: null
      },
      getDynamicFieldsTemplate: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapStateDepartment(['departments']),
      computedPlaceholder() {
        if (this.options && this.options.placeholder) {
          return this.options.placeholder
        }
        return this.$i18n.t('Select Category')
      },
      treePickerOptions() {
        return {
          normalizer: (node) => {
            return {
              id: node.uuid,
              label: Formatter.getByMasterLanguage(node.name),
              children: node.children,
            }
          }
        }
      }
    },
    watch: {
      'department': {
        deep: true,
        handler() {
          this.initCategories();
        }
      },
      propItems() {
        this.items = this.propItems
      }
    },
    methods: {
      initCategories() {
        this.items = [];

        if (this.department || this.withAllCategories) {

          let departments = this.departments.rows;
          if (this.department) {
            departments = [this.departments.rows.find(dept => dept.uuid === this.department.uuid)];
          }

          for (let d of departments) {
            if (d && d.categories) {
              this.items = [...this.items, ...d.categories];
            }
          }
        }
      },
      async onSelect(data) {
        if (this.getDynamicFieldsTemplate) {
          let response = await CategoryService.getCategory(data.uuid, {
            expand: 'dynamic_fields_template'
          })
          if (response.success) {
            data['dynamic_fields_template'] = response.body.dynamic_fields_template
          }
        }
        this.$emit('select', data);
      }
    },
    mounted() {
      this.initCategories();
    }
  }
</script>

<style scoped>

</style>
